module.exports = __webpack_public_path__ + "img/iconjama.db0a15ed.png";